import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Spinner } from "@/components/ui/spinner";

export function PublicRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" className="text-primary" label="Checking authentication..." />
      </div>
    );
  }

  if (isAuthenticated) {
    // Redirect to the page they were trying to visit, or dashboard
    const from = location.state?.from?.pathname || "/app";
    return <Navigate to={from} replace />;
  }

  return <Outlet />;
}
